import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import ErrorMessage from '../../../components/ErrorMessage';
export default function PickupSection({ pickup, translate: t, SelectField, busy, pendingPickup, pickupError, selectionError, onPickupChange, }) {
    const { selection, locations, location, methods, resellers, availabilityError, noLocations } = pickup;
    const options = [
        ...(methods.includes('store') ? [{ id: 'store', name: t('one_page_checkout.store_pickup') }] : []),
        ...resellers.map(item => ({
            id: `reseller:${item.id}`,
            name: item.name,
            logo: item.logo,
            disabled: pickup.locationDisabled,
        })),
    ];
    let value = selection.method === 'store' ? 'store' : '';
    if (selection.method === 'reseller' && selection.id)
        value = `reseller:${selection.id}`;
    const automaticSelection = useRef(null);
    useEffect(() => {
        if (busy || pickupError || selectionError)
            return;
        let next = null;
        if (selection.method === 'store' && selection.id === null && locations.length === 1) {
            next = { method: 'store', id: locations[0].id };
        }
        else if (selection.method !== 'store' && selection.id === null && options.length === 1 && !options[0].disabled) {
            next = options[0].id === 'store' ? { method: 'store', id: null } : { method: 'reseller', id: resellers[0].id };
        }
        if (!next) {
            automaticSelection.current = null;
            return;
        }
        const key = `${next.method}:${next.id}`;
        if (automaticSelection.current === key)
            return;
        // Keep a failed automatic selection blocked until the customer chooses to retry.
        automaticSelection.current = key;
        onPickupChange(next.method, next.id);
    }, [busy, pickupError, selectionError, selection, locations, options, resellers, onPickupChange]);
    return (_jsxs(_Fragment, { children: [noLocations && (_jsx("p", { className: "mt-3", role: "alert", children: t('one_page_checkout.no_pickup') })), options.length > 0 && (_jsx(SelectField, { label: t('one_page_checkout.delivery_method'), value: value, onChange: selectedValue => {
                    if (selectedValue === 'store') {
                        onPickupChange('store', null);
                        return;
                    }
                    const reseller = resellers.find(item => selectedValue === `reseller:${item.id}`);
                    onPickupChange(reseller ? 'reseller' : null, reseller?.id ?? null);
                }, disabled: busy, loading: pendingPickup?.method === 'reseller', options: options })), availabilityError && _jsx(ErrorMessage, { className: "mt-3", children: availabilityError }), !noLocations && selection.method === 'store' && (_jsx(SelectField, { label: t('one_page_checkout.store'), value: selection.id?.toString() || '', onChange: value => onPickupChange(selection.method, value ? Number(value) : null), disabled: busy, loading: Boolean(pendingPickup), options: locations.map(item => ({
                    id: item.id.toString(),
                    name: item.name,
                })) })), (pickupError || selectionError) && _jsx(ErrorMessage, { className: "mt-3", children: pickupError || selectionError }), !pendingPickup && selection.method === 'reseller' && location && (_jsx("div", { className: "opc-location-info my-3", children: location.description && _jsx("p", { children: location.description }) }))] }));
}
